// @module NXTurn.ShoppingExtensions.LoginRegister
define('C3.ShoppingExtensions.PDP.SetsIncluded.Item.MainView'
,	[
	  'c3_shoppingextensions_setsincludeditem_mainview.tpl'
	,   'C3.ShoppingExtensions.PDP.SetsIncluded.Item.View'
    ,   'Utils'
    ]
, function (
	   c3_shoppingextensions_setsincludeditem_mainview_tpl
	,   SetsIncludedItemView
    ,  Utils
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.LoginRegister.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_setsincludeditem_mainview_tpl

	,	initialize: function (options) {
		    this.options = options;
			//console.log(this.options)
			this.application = options.application;
			//this.layout = options.layout;
			this.configuration = options.configuration;
			this.container = options.container;
			this.itemsIds = options.itemsIds;
		}


	,   events: {
    	'click [data-action="pdp-setsincluded-click"]': 'arrowClicked'
    }
    
    ,   arrowClicked: function arrowClicked(e){
    	
    	const anchor = jQuery(e.currentTarget)
    	,     data_attr = anchor.attr('data-click')
	    ,     sibling = anchor.siblings()

	    //console.log(anchor)
	    if(data_attr == 'right-click')
	    {
	    	//console.log(anchor.hasClass('disabled'))
	    	//console.log(sibling.hasClass('disabled'))
	    	if(anchor.hasClass('disabled'))
	    	{
	    		$('.pdp-setsincluded.carousel-items-next-icon .right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow-Grey.svg')
	    	}

	    	if(sibling.hasClass('disabled'))
	    	{
	    		$('.pdp-setsincluded.carousel-items-prev-icon .left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg')	    		
	    	}
	    	else
	    	{
	    		$('.pdp-setsincluded.carousel-items-prev-icon .left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow.svg')
	    	}
	    }
	    else if(data_attr == 'left-click')
	    {
	    	if(anchor.hasClass('disabled'))
	    	{
	    		$('.pdp-setsincluded.carousel-items-prev-icon .left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg')
	    	
	    	}
	    	if(sibling.hasClass('disabled'))
	    	{
	    		$('.pdp-setsincluded.carousel-items-next-icon .right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow-Grey.svg')
	    	}
	    	else
	    	{
	    		$('.pdp-setsincluded.carousel-items-next-icon .right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg')
	    	}
	    }
	   
    }	

	, 	childViews: {
			'SetsIncluded.Carousel.Items': function ()
      		{
     			var self = this;
     			//console.log(this.itemsIds)
     			return new SetsIncludedItemView({
				  	application: this.application,
				  	itemsIds : this.itemsIds,
				  	configuration : this.configuration,
				  	container : this.container
				  });

      		}
		}


		//@method getContext @return NXTurn.ShoppingExtensions.LoginRegister.View.Context
	,	getContext: function getContext()
		{

			return {
				
			};
		}
	});
});
